import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0 md:mt-8 md:mx-auto container"
}
const _hoisted_2 = { class: "w-full shadow rounded mb-8" }
const _hoisted_3 = { class: "bg-gray-700 flex-col md:flex-row flex rounded-t" }
const _hoisted_4 = { class: "flex p-4 md:w-4/5" }
const _hoisted_5 = {
  key: 1,
  class: "text-2xl text-white break-all text-center"
}
const _hoisted_6 = {
  key: 1,
  class: "text-2xl text-white break-all text-center"
}
const _hoisted_7 = { class: "bg-black text-white p-2 pl-4 flex justify-between" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_image = _resolveComponent("b-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_site_scene_list = _resolveComponent("site-scene-list")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createBlock(_component_b_overlay, {
    show: _ctx.$apollo.loading
  }, {
    default: _withCtx(() => [
      (_ctx.site)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.site.logo)
                    ? (_openBlock(), _createBlock(_component_b_image, {
                        key: 0,
                        src: _ctx.site.logo.url,
                        class: "max-h-24 object-contain"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.site.name), 1))
                ]),
                (_ctx.site.network)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/networks/${_ctx.site.network.short_name}`,
                      class: "p-4 md:w-1/5 flex md:justify-end items-center"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.site.network.logo)
                          ? (_openBlock(), _createBlock(_component_b_image, {
                              key: 0,
                              src: _ctx.site.network.logo.url,
                              class: "max-h-24 object-contain"
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_ctx.site.network.name), 1))
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.site.name), 1),
                _hoisted_9
              ]),
              (_ctx.site.id)
                ? (_openBlock(), _createBlock(_component_site_scene_list, {
                    key: 0,
                    site: _ctx.site
                  }, null, 8, ["site"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show"]))
}